import React from "react";
import styled from "@emotion/styled";
import { Box, Link, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { NewsItemSkeleton } from "@components";
import { ShortNewsItem, NewsItem } from "./ShortNewsItem";

const ShortNewsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 9px;
  width: fit-content;
  gap: ${({ theme }) => theme.spacing(5)};
`;

interface ShortNewsProps {
  news: NewsItem[];
  isFetching?: boolean;
}

export const ShortNews = (props: ShortNewsProps) => {
  const { news = [], isFetching } = props;
  const { t } = useTranslation();

  if (isFetching) {
    return (
      <Box display="flex" flexDirection="column" gap={2}>
        <NewsItemSkeleton />
        <NewsItemSkeleton />
        <NewsItemSkeleton />
        <NewsItemSkeleton />
      </Box>
    );
  }

  return (
    <ShortNewsWrapper>
      {news.map((item, index) => (
        <ShortNewsItem
          key={item.link}
          {...item}
          showBorder={index !== news.length - 1}
        />
      ))}

      <Link
        href="https://blog.rentablo.de"
        underline="hover"
        mt={2}
        ml={3}
        width="fit-content"
      >
        <Typography variant="body3" fontWeight={600}>
          {t("dashboardPage.dashboard.newsBlock.allArticles")}
        </Typography>
      </Link>
    </ShortNewsWrapper>
  );
};
